import View from './View';

export { default as View, getManageButtonStyle } from './View';

export default View;
